export default __webpack_public_path__ + "static/media/jticookie.8e280fd0.pdf";